/* eslint-disable react-hooks/exhaustive-deps */
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getDoulingo, updateDoulingo } from 'app/testingSlice/testingSlice';
import { checkEnableParseJSON, optionValues } from 'components/helper/helper';
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import SelectInput from 'components/input/SelectInput';
import YesNoSwitch from 'components/input/YesNoSwitch';
import GroupRadioButton from 'components/input/GroupRadioButton';
import DatePickerInput from 'components/input/DatePicker';
import { debounce } from 'lodash';
import Grid from '@mui/joy/Grid';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

type Props = {};
const formatScore = (x: any) => {
  return Number.parseFloat(x).toFixed(1);
};
const DuoLingoTest = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const testing = useAppSelector((store) => store.testing);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();

  const formik = useFormik({
    initialValues: {
      number_of_time_taken_duolingo: '',
      duolingo_received_score: '',
      duolingo_plan_on_retake: '',
      number_of_future_duolingo_expect: '',
      duolingo_date_retake: {
        test1: '',
        test2: '',
        test3: '',
      },
      duolingo_literacy_score: '',
      duolingo_conversation_score: '',
      duolingo_comprehension_score: '',
      duolingo_production_score: '',
      duolingo_overall_score: '',
      duolingo_highest_literacy_score: '',
      duolingo_highest_literacy_date: '',
      duolingo_highest_comprehension_score: '',
      duolingo_highest_comprehension_date: '',
      duolingo_highest_conversation_score: '',
      duolingo_highest_conversation_date: '',
      duolingo_highest_production_score: '',
      duolingo_highest_production_date: '',
      duolingo_highest_total_score: '',
      duolingo_highest_total_date: '',
    },
    onSubmit: async (values) => {
      const newValues = {
        ...values,
        duolingo_date_retake: JSON.stringify(values.duolingo_date_retake),
        student_id: studentId,
      };
      await dispatch(updateDoulingo(newValues));
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    const nextRoute = Object.keys(testing.roleTest).find(
      (key, index) =>
        index > Object.keys(testing.roleTest).indexOf('douLingoTest') &&
        testing.roleTest[key] === true
    );
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.activities.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      let res = await dispatch(getDoulingo(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        const values: any = {
          ...formik.values,
          ...dataLoaded,
          duolingo_date_retake: checkEnableParseJSON(dataLoaded.duolingo_date_retake),
        };
        formik.setValues(values);
      }
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Auto save function ==========
  const notInitialRender = React.useRef(false);
  React.useEffect(() => {
    debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (notInitialRender.current) {
        if (!loading) formik.handleSubmit();
      } else {
        notInitialRender.current = true;
      }
    }, 1500),
    []
  );
  // Auto save function ==========
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[{ title: 'Duo Lingo', percentOnProcess: 20 }]}
        title="Standardized Testing"
        process={1}
        icon={<CalculateOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Duolingo
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <SelectInput
                  form={formik}
                  label="Number of times you have already taken a Duolingo English Test*"
                  option={optionValues(Array.from({ length: 6 }, (_, i) => i))}
                  name="number_of_time_taken_duolingo"
                  values={formik.values.number_of_time_taken_duolingo}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  label="Have you received your scores yet?*"
                  name="duolingo_received_score"
                  values={formik.values.duolingo_received_score}
                  onChange={formik.handleChange}
                />
              </Grid>

                                <Grid xs={6}>
                <SelectInput
                  name="duolingo_highest_literacy_score"
                  label="Highest literacy score*"
                  values={formik.values.duolingo_highest_literacy_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(31).keys()).map((item) => `${item * 5 + 10}`)}
                />
              </Grid>
                                <Grid xs={6}>
                <DatePickerInput
                  label="Literacy score date*"
                  name="duolingo_highest_literacy_date"
                  values={formik.values.duolingo_highest_literacy_date}
                  onChange={(values) =>
                    formik.setFieldValue('duolingo_highest_literacy_date', values)
                  }
                />
              </Grid>
                                <Grid xs={6}>
                <SelectInput
                  name="duolingo_highest_comprehension_score"
                  label="Highest comprehension score*"
                  values={formik.values.duolingo_highest_comprehension_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(31).keys()).map((item) => `${item * 5 + 10}`)}
                />
              </Grid>
                                <Grid xs={6}>
                <DatePickerInput
                  label="Comprehension score date*"
                  name="duolingo_highest_comprehension_date"
                  values={formik.values.duolingo_highest_comprehension_date}
                  onChange={(values) =>
                    formik.setFieldValue('duolingo_highest_comprehension_date', values)
                  }
                />
              </Grid>
                                <Grid xs={6}>
                <SelectInput
                  name="duolingo_highest_conversation_score"
                  label="Highest conversation score*"
                  values={formik.values.duolingo_highest_conversation_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(31).keys()).map((item) => `${item * 5 + 10}`)}
                />
              </Grid>
                                <Grid xs={6}>
                <DatePickerInput
                  label="Conversation score date*"
                  name="duolingo_highest_conversation_date"
                  values={formik.values.duolingo_highest_conversation_date}
                  onChange={(values) =>
                    formik.setFieldValue('duolingo_highest_conversation_date', values)
                  }
                />
              </Grid>
                                <Grid xs={6}>
                <SelectInput
                  name="duolingo_highest_production_score"
                  label="Highest production score*"
                  values={formik.values.duolingo_highest_production_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(31).keys()).map((item) => `${item * 5 + 10}`)}
                />
              </Grid>
                                <Grid xs={6}>
                <DatePickerInput
                  label="Production score date*"
                  name="duolingo_highest_production_date"
                  values={formik.values.duolingo_highest_production_date}
                  onChange={(values) =>
                    formik.setFieldValue('duolingo_highest_production_date', values)
                  }
                />
              </Grid>
                                <Grid xs={6}>
                <SelectInput
                  name="duolingo_highest_total_score"
                  label="Highest Duolingo total score*"
                  values={formik.values.duolingo_highest_total_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(31).keys()).map((item) => `${item * 5 + 10}`)}
                />
              </Grid>
                                <Grid xs={6}>
                <DatePickerInput
                  label="Duolingo total score date*"
                  name="duolingo_highest_total_date"
                  values={formik.values.duolingo_highest_total_date}
                  onChange={(values) => formik.setFieldValue('duolingo_highest_total_date', values)}
                />
              </Grid>

              <Grid xs={12}>
                <div className={`gm-section-subtitle ${isMobile ? 'mt-2 mb-2' : 'mt-4 mb-3'}`}>
                  <span style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: 600 }}>
                    Scores
                  </span>
                </div>
              </Grid>
              <Grid xs={4}>
                <SelectInput
                  name="duolingo_literacy_score"
                  label="Literacy*"
                  values={formik.values.duolingo_literacy_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(18).keys()).map((item) => formatScore(item / 2 + 0.5))}
                />
              </Grid>
              <Grid xs={4}>
                <SelectInput
                  name="duolingo_conversation_score"
                  label="Conversation*"
                  values={formik.values.duolingo_conversation_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(18).keys()).map((item) => formatScore(item / 2 + 0.5))}
                />
              </Grid>
              <Grid xs={4}>
                <SelectInput
                  name="duolingo_comprehension_score"
                  label="Comprehension*"
                  values={formik.values.duolingo_comprehension_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(18).keys()).map((item) => formatScore(item / 2 + 0.5))}
                />
              </Grid>
                                <Grid xs={6}>
                <SelectInput
                  name="duolingo_production_score"
                  label="Production*"
                  values={formik.values.duolingo_production_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(18).keys()).map((item) => formatScore(item / 2 + 0.5))}
                />
              </Grid>
                                <Grid xs={6}>
                <SelectInput
                  name="duolingo_overall_score"
                  label="Overall Score*"
                  values={formik.values.duolingo_overall_score}
                  onChange={formik.handleChange}
                  option={Array.from(Array(18).keys()).map((item) => formatScore(item / 2 + 0.5))}
                />
              </Grid>
              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  label="Do you plan on retaking this test?*"
                  values={formik.values.duolingo_plan_on_retake}
                  onChange={formik.handleChange}
                  name="duolingo_plan_on_retake"
                />
              </Grid>
              {formik.values.duolingo_plan_on_retake === 'true' && (
                <>
                  <Grid xs={12}>
                    <GroupRadioButton
                      label="Number of future Duolingo sittings you expect*"
                      options={['0', '1', '2', '3']}
                      values={formik.values.number_of_future_duolingo_expect}
                      onChange={formik.handleChange}
                      name="number_of_future_duolingo_expect"
                    />
                  </Grid>
                  {[1, '1', '2', '3', 2, 3].includes(
                    formik.values.number_of_future_duolingo_expect
                  ) && (
                    <Grid xs={12}>
                      <DatePickerInput
                        className="common-flag"
                        label={`Future testing date 1*`}
                        name="duolingo_date_retake.test1"
                        values={formik.values?.duolingo_date_retake?.test1}
                        onChange={(values) =>
                          formik.setFieldValue('duolingo_date_retake.test1', values)
                        }
                      />
                    </Grid>
                  )}
                  {['2', '3', 2, 3].includes(formik.values.number_of_future_duolingo_expect) && (
                    <Grid xs={12}>
                      <DatePickerInput
                        className="common-flag end-flag"
                        label={`Future testing date 2*`}
                        name="duolingo_date_retake.test2"
                        values={formik.values?.duolingo_date_retake?.test2}
                        onChange={(values) =>
                          formik.setFieldValue('duolingo_date_retake.test2', values)
                        }
                      />
                    </Grid>
                  )}
                  {['3', 3].includes(formik.values.number_of_future_duolingo_expect) && (
                    <Grid xs={12}>
                      <DatePickerInput
                        className="common-flag"
                        label={`Future testing date 3*`}
                        name="duolingo_date_retake.test3"
                        values={formik.values?.duolingo_date_retake?.test3}
                        onChange={(values) =>
                          formik.setFieldValue('duolingo_date_retake.test3', values)
                        }
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-end'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {testing.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </>
  );
};

export default DuoLingoTest;
